<template>
    <button v-on:click="download" :class="getCSSClass('download-label-button')" v-html="label"></button>
</template>

<script>
export default {
    inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
    props: {
        operationsUrl: {type: String},
        filename: {type: String},
        label: {type: String}
    },
    data: function () {
        return {}
    },
    mounted() {
    },
    methods: {
        download: function() {
            window.axios.post(this.operationsUrl, {
                operation: 'getDownloadLink',
                file: this.filename,
                version: null
            }).then((response) => {
                let a = document.createElement('a');
                a.setAttribute('target', '_blank');
                a.setAttribute('href', response.data);
                document.body.appendChild(a);
                a.click();
                a.remove();
            }).catch((error) => {
                if (!this.showUnauthorizedNotificationIfApplies(error)) {
                    alert(this.translate('A fájl nem tölthető le.'));
                }
            });
        },
    },
    computed: {},
    watch: {}

}
</script>
